import React, { useState, useRef, useEffect } from 'react';
import { Search } from 'lucide-react';

const ChampionAutocomplete = ({ champions, value, onChange }) => {
  const [inputValue, setInputValue] = useState(value || '');
  const [isOpen, setIsOpen] = useState(false);
  const [filteredChampions, setFilteredChampions] = useState([]);
  const wrapperRef = useRef(null);

  useEffect(() => {
    setInputValue(value || '');
  }, [value]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleInputChange = (e) => {
    const input = e.target.value;
    setInputValue(input);
    setIsOpen(true);

    const filtered = champions.filter(champion =>
      champion.toLowerCase().includes(input.toLowerCase())
    );
    setFilteredChampions(filtered);

    // Only update parent if it's an exact match
    if (champions.includes(input)) {
      onChange(input);
    } else {
      onChange('');
    }
  };

  const handleSelectChampion = (champion) => {
    setInputValue(champion);
    onChange(champion);
    setIsOpen(false);
  };

  return (
    <div className="relative" ref={wrapperRef}>
      <div className="relative">
        <input
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          onFocus={() => {
            setIsOpen(true);
            setFilteredChampions(
              champions.filter(champion =>
                champion.toLowerCase().includes(inputValue.toLowerCase())
              )
            );
          }}
          className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-100"
          placeholder="Type champion name..."
        />
        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
          <Search className="h-5 w-5 text-gray-400" />
        </div>
      </div>
      
      {isOpen && filteredChampions.length > 0 && (
        <ul className="absolute z-10 w-full mt-1 bg-gray-800 border border-gray-700 rounded-md shadow-lg max-h-60 overflow-auto">
          {filteredChampions.map((champion) => (
            <li
              key={champion}
              onClick={() => handleSelectChampion(champion)}
              className="px-4 py-2 hover:bg-gray-700 cursor-pointer text-gray-100"
            >
              {champion}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ChampionAutocomplete;
